import { Control, Controller, FieldValues, RegisterOptions, useFormContext } from "@graphcommerce/ecommerce-ui";
import { ClassAttributes, SelectHTMLAttributes, useEffect } from "react";
type SelectFieldElementProps = {
  control?: Control<FieldValues>
  name: string
  label: string
  fullWidth?: boolean
  rules?: Omit<RegisterOptions<FieldValues, string>, "valueAsNumber" | "valueAsDate" | "setValueAs" | "disabled">
} & ClassAttributes<HTMLSelectElement> & SelectHTMLAttributes<HTMLSelectElement>
export default function SelectFieldElement({ control, defaultValue, name, required, label, children, rules, fullWidth = false }: SelectFieldElementProps) {
  const { formState: { errors }, control: controlState, setValue } = useFormContext();

  useEffect(() => {
    if (defaultValue) {
      setValue(name, defaultValue)
    }
  }, [defaultValue])
  return (
    <div>
      <Controller
        name={name}
        control={control ?? controlState}
        rules={{
          ...(required ? { required: `انتخاب ${label} الزامی است.` } : null),
          ...rules
        }}
        render={({ field }) => (
          <div className={`flex ${fullWidth ? 'flex-col' : 'items-center'} gap-2`}>
            {label && <label className="ml-3">{label} {required && <span className="text-error-500">{'*'}</span>}</label>}
            <select {...field} className={`text-sm ${fullWidth && 'w-full'} h-8 py-1 px-3 border border-solid border-light-170 rounded-sm outline-0 shadow-none ${errors[name] ? 'border-error-500' : 'border-light-170'}`}>
              {children}
            </select>
          </div>
        )}
      />
      {errors[name] ? <p className="text-xs text-error-500 my-0">{errors[name]?.message as string}</p> : null}
    </div>

  )
}